export const setRestaurants = (restaurants) => ({
    type: 'SET_RESTAURANTS',
    restaurants
});